import Swiper, { Pagination, Navigation, Thumbs, EffectFade } from 'swiper'

Swiper.use([Pagination, Navigation, Thumbs, EffectFade])

export default {
	init() {
		const swiper = new Swiper('.small', {
			spaceBetween: 6,
			slidesPerView: 5,
			freeMode: true,
			watchSlidesProgress: true,
		})
		const swiper2 = new Swiper('.big', {
			spaceBetween: 10,
			autoHeight: true,
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			pagination: {
				el: '.news-pagination-swiper',
				type: 'fraction',
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			thumbs: {
				swiper: swiper,
			},
		})
	},
}
